<template>
  <div class="plan-add pt-2 pr-2 text-right relative" v-if="editable">
    <a v-on:click="toggleAddPlaceMenu" class="btn-plan-add text-btn_secondary">{{ $t('tour_add_destination_label') }}</a>
    <add-place-menu
      v-show="showAddPlaceMenu"
      @newPlace="onNewPlace"
      @newPlaceFromMap="onNewPlaceFromMap"/>
  </div>
</template>

<script>
import AddPlaceMenu from "./AddPlaceMenu"

export default {
  props: {
    editable: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    newPlace: {
      type: Function,
      default: function () {
        return {}
      }
    },
    newPlaceFromMap: {
      type: Function,
      default: function () {
        return {}
      }
    },
  },
  components: {
    AddPlaceMenu
  },
  data () {
    return {
      showAddPlaceMenu: false
    }
  },
  methods: {
    toggleAddPlaceMenu: function () {
      this.showAddPlaceMenu = !this.showAddPlaceMenu
    },
    onNewPlace: function () {
      this.showAddPlaceMenu = false
      this.newPlace()
    },
    onNewPlaceFromMap: function () {
      this.showAddPlaceMenu = false
      this.newPlaceFromMap()
    }
  }
}
</script>
